import Content from "./Content";
import ContentFactory from "./ContentFactory";

/**
 * VariableMutationNumberContent.js
 * 
 * Created on Oct 8, 2013, 10:12:15 AM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class VariableMutationNumberContent extends Content {
    constructor(languagePack, contentID, label) {
        super(VariableMutationNumberContent.NAME, VariableMutationNumberContent.TYPE, label, languagePack, contentID, true, true);
    }

    remove() {
        this.removeLanguagePackText(VariableMutationNumberContent.VARIABLE_NAME_TEXT_LABEL);
        this.remove();
    }

    clone() {
        clone = new VariableMutationNumberContent(ContentFactory.getContent(VariableMutationNumberContent.TYPE, this.getLanguagePack()));
        clone._contentID = this._contentID;
        clone.setVariableName(this.getVariableName());
        clone.setMutationType(this.getMutationType());
        clone.setValue(this.getValue());
        return clone;
    }

    getValue() {
        return this.value;
    }

    setValue(value) {
        this.value = parseFloat(value);
    }

    getMutationType() {
        return this.mutationType;
    }

    setMutationType(value) {
        this.mutationType = value;
    }

    getVariableName() {
        return this.getLanguagePackText(VariableMutationNumberContent.VARIABLE_NAME_TEXT_LABEL);
    }

    setVariableName(value) {
        if (this.getVariableName() !== value) {
            this.setLanguagePackText(VariableMutationNumberContent.VARIABLE_NAME_TEXT_LABEL, value);
        }
    }

    convertToObject() {
        return this.getObject(["mutationType", "value"]);
    }
}

VariableMutationNumberContent.NAME = "Variable Mutation (Number)";
VariableMutationNumberContent.TYPE = "engVariableMutationNumberContent";
VariableMutationNumberContent.VARIABLE_NAME_TEXT_LABEL = "variableName";
VariableMutationNumberContent.ADD = 0;
VariableMutationNumberContent.SET = 1;
VariableMutationNumberContent.SUBTRACT = 2;
VariableMutationNumberContent.MULTIPLY = 3;
VariableMutationNumberContent.DIVIDE = 4;
